var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select',{attrs:{"value":_vm.value,"multiple":_vm.props.multiple || false,"clearable":_vm.clearable,"filterable":_vm.filterable},on:{"on-change":_vm.onChange}},_vm._l((_vm.opl),function(item){return _c('Option',{key:item.value,attrs:{"value":item.value}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }